import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=9b811538&scoped=true&"
import script from "./transactionDetail.vue?vue&type=script&lang=js&"
export * from "./transactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=9b811538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b811538",
  null
  
)

export default component.exports